import { render } from "./app.vue?vue&type=template&id=2d04b028"
const script = {}

import "./app.vue?vue&type=style&index=0&id=2d04b028&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__